import {
  CreateNewTaskResponse,
  BaseReducerState,
  Task,
} from '../../../services'
import { ActionTypes } from '../actions'

export type CreateNewTaskState = BaseReducerState & {
  data: Task
}

export const initialState: CreateNewTaskState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const createNewTask = (
  state: CreateNewTaskState = initialState,
  action: { type: string; res: any }
): CreateNewTaskState => {
  switch (action.type) {
    case `${ActionTypes.CREATE_NEW_TASK}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.CREATE_NEW_TASK}_SUCCESS`: {
      const { success, data, message } = <CreateNewTaskResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.CREATE_NEW_TASK}_FAILURE`:
      const res = <CreateNewTaskResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.CREATE_NEW_TASK}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
